import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import imagePreloader from 'vue-image-preloader';

import store from './store';
import App from './App';
import Index from './Index';
import DiseaseState from './DiseaseState';
import SelectProduct from './SelectProduct';
import TrialsOne from './TrialsOne';
import TrialsTwo from './TrialsTwo';
// import Timeline from './Timeline';
import SearchResults from './SearchResults';
import Config from './Config';
import Grid from './Grid';
import analytics from "./components/analytics";
import simpleAnalytics from "./components/simpleAnalytics";

Vue.use(VueRouter);
Vue.use(Vuex);

Vue.use(require('vue-moment'));
Vue.use(imagePreloader);

const routes = [
    { path: '/', component: Index, name: 'Home Screen', meta: { screenClass: 'HomeScreen' } },
    { path: '/disease-state', component: DiseaseState, name: 'Disease State', meta: { screenClass: 'DiseaseStateScreen' } },
    { path: '/trials-one', component: TrialsOne, name: 'Trials One', meta: { screenClass: 'TrialsOneScreen' } },
    { path: '/trials-two/:id?', component: TrialsTwo, name: 'Trials Two', meta: { screenClass: 'TrialsTwoScreen' } },
    { path: '/select-product', component: SelectProduct, name: 'Product Page', meta: { screenClass: 'ProductScreen' } },
    { path: '/timeline/:filtertype?/:filtervalue?', component: Grid, name: 'Grid', meta: { screenClass: 'GridScreen' } }, //was timeline
    {
        path: '/see-all',
        component: Grid, //was timeline
        name: 'Timeline',
        meta: { screenClass: 'TimelineScreen' },
        beforeEnter: (to, from, next) => {
            window.location.reload();
            next();
        }
    },
    { path: '/search-results/:term?', component: SearchResults, name: 'Search', meta: { screenClass: 'SearchScreen' } },
    { path: '/config', component: Config, name: 'Config', meta: { screenClass: 'ConfigScreen' } },
    { path: '/all-trials', redirect: { name: 'Grid' } },
    { path: '/grid', component: Grid, name: 'Grid View', meta: { screenClass: 'GridViewScreen' } },
];

const router = new VueRouter({
    routes
});

window.trackSpool = [];

router.afterEach((to) => {

    if (window.App) {
        if (to.name) {
            window.App.track("callback://screenname_" + to.name);
        }
    } else {
        window.trackSpool.push("callback://screenname_" + to.name);
    }
});

Vue.config.productionTip = false;
Vue.prototype.analytics = analytics; // Attach Google gtag object
Vue.prototype.isIpad = window.env && window.env.isIpad;
Vue.prototype.$analytics = simpleAnalytics; // Attach Google gtag object


window.App = new Vue({
    el: '#app',
    store: store,
    render: h => h(App),
    router: router,
    mounted: function () {
        this.pollTracker();
        this.allowDesktopScaling();
        this.fitIpadViewport();
        this.fitNarrowLayout();

        // Initialize analytics when app is mounted
        this.analytics.init();

        const consent = localStorage.getItem('analytics_consent');
        if (consent === 'true') {
            this.$analytics.enable();
        }
    },
    data: {
        trackSpool: [],
    },
    watch: {
        $route(to) {
            if (this.$analytics.enabled) {
                const screenClass = to.meta.screenClass || '';
                this.$analytics.trackPage(to.path, to.name, screenClass);
            }

            // Track route changes with page title and screen class
            const pageTitle = to.name || document.title;
            const screenClass = to.meta.screenClass || '';
            
            // Track with all three parameters
            this.analytics.trackRoute(to.path, pageTitle, screenClass);
        }
    },
    methods: {
        track: function (url) {
            if (window.env && window.env.isIpad) {
                window.trackSpool.push(url);
            }
        },
        pollTracker: function () {
            if (window.env && window.env.isIpad) {
                if (window.trackSpool.length > 0) {
                    window.location.assign(window.trackSpool.shift());
                }
                setTimeout(this.pollTracker, 250);
            }
        },
        allowDesktopScaling: function () {
            if (!('ontouchstart' in window && navigator.maxTouchPoints > 1)) {
                const viewport = document.querySelector('meta[name="viewport"]');
                viewport.setAttribute('content', 'width=device-width,initial-scale=1.0');
            }
        },
        fitIpadViewport: function () {
            const viewport = document.querySelector('meta[name="viewport"]');
            if (!viewport) {
                return;
            }

            const apply = () => {
                const isTouch = ('ontouchstart' in window && navigator.maxTouchPoints > 1);
                if (!isTouch) {
                    return;
                }

                const isLandscape = window.matchMedia('(orientation: landscape)').matches;
                const shortSide = Math.min(window.screen.width, window.screen.height);
                const longSide = Math.max(window.screen.width, window.screen.height);
                const width = isLandscape ? longSide : shortSide;

                if (width < 1180) {
                    viewport.setAttribute('content', 'width=1180, user-scalable=no');
                } else {
                    viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
                }
            };

            apply();
            window.addEventListener('orientationchange', () => {
                setTimeout(apply, 250);
            });
        },
        fitNarrowLayout: function () {
            const fit = 1180;
            const html = document.documentElement;
            const apply = () => {
                const vw = window.innerWidth;
                const vh = window.innerHeight;
                const clearZoom = function () {
                    html.style.zoom = '';
                    html.style.minHeight = '';
                };

                if (vw >= fit) {
                    clearZoom();
                    html.style.width = '';
                    html.classList.remove('is-fit-width');
                    return;
                }

                html.style.width = fit + 'px';
                html.style.zoom = String(vw / fit);
                html.style.minHeight = ((vh * fit) / vw) + 'px';
                html.classList.add('is-fit-width');

                const applied = parseFloat(html.style.zoom);
                const rectWidth = html.getBoundingClientRect().width;
                const zoomed = applied && Math.abs(applied - 1) > 0.001 && Math.abs(rectWidth - vw) < 40;
                if (!zoomed) {
                    clearZoom();
                    html.style.width = '';
                    html.classList.add('is-fit-width');
                }
            };

            apply();
            window.addEventListener('resize', apply);
            window.addEventListener('orientationchange', () => {
                setTimeout(apply, 250);
            });
        },
    }
});
